/** Тип предложения */
export enum FOfferType {
  /** Do not use */
  Unexpected = 0,
  /** Квартира во вторичке */
  FlatOld = 1 << 1,
  /** Квартира в новостройке */
  FlatNew = 1 << 2,
  /** Квартира */
  Flat = FlatOld | FlatNew,
  /** Доля в квартире */
  FlatShared = 1 << 3,
  /** Комната */
  Room = 1 << 4,
  /** Койко-место */
  Bed = 1 << 5,
  /** Городская недвижимость */
  Urban = Flat | FlatShared | Room | Bed,
  /** Дом */
  House = 1 << 6,
  /** Часть дома */
  HousePart = 1 << 7,
  /** Таунхаус */
  Townhouse = 1 << 8,
  /** Участок */
  Land = 1 << 9,
  /** Загородная недвижимость */
  Suburban = House | HousePart | Townhouse | Land,
  /** Гараж */
  Garage = 1 << 10,
  /** Другая недвижимость */
  Other = Garage,
  /** Отель, они хранятся в RentDaily и отображаются только с параметром show_hotels=true */
  Hotel = 1 << 23,
  /** Жилая и другая недвижимость */
  Residential = Urban | Suburban | Hotel | Other,
  /** Офис */
  Office = 1 << 11,
  /** Торговая площадь */
  TradeArea = 1 << 12,
  /** Склад */
  Warehouse = 1 << 13,
  /** Помещение свободного назначения */
  FreeAppointmentObject = 1 << 14,
  /** Общепит */
  PublicCatering = 1 << 15,
  /** Производство */
  Manufacture = 1 << 16,
  /** Автосервис */
  AutoService = 1 << 17,
  /** Готовый бизнес */
  ReadyBusiness = 1 << 18,
  /** Арендный бизнес */
  RentalBusiness = 1 << 19,
  /** Бизнес */
  Business = ReadyBusiness | RentalBusiness,
  /** Здание */
  Building = 1 << 20,
  /** Бытовые услуги */
  DomesticServices = 1 << 21,
  /** Коммерческая земля */
  CommercialLand = 1 << 22,
  /** Офис в коворкинге */
  CoworkingOffice = 1 << 24,
  /** Рабочее место */
  CoworkingWorkspace = 1 << 25,
  /** Коворкинг */
  Coworking = CoworkingOffice | CoworkingWorkspace,
  /** Коммерческая недвижимость */
  Commercial = Office |
    TradeArea |
    Warehouse |
    FreeAppointmentObject |
    PublicCatering |
    Manufacture |
    AutoService |
    Business |
    Building |
    DomesticServices |
    CommercialLand |
    Coworking,
  /** Любая недвижимость */
  Any = Residential | Commercial,
}
